import { login, logout, getInfo, modifyPassword, register } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import Layout from '../../views/layout/Layout'
import { queryDevices } from '@/api/device'
import router from '../../router'
import Cookies from 'js-cookie'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    role: 1,
    userid: 0,
    devices: [],
    // routeState: false,
    routes: [
      { path: '/login', component: () => import('@/views/login'), hidden: true },
      { path: '/404', component: () => import('@/views/404'), hidden: true },
      { path: '/', component: () => import('@/views/HomeView.vue'), hidden: false },

      {
        path: '/stations',
        component: Layout,
        name: 'stations',
        meta: { title: '站 点', icon: 'example' },
        alwaysShow: true,
        children: []
      },
      {
        path: '/person',
        component: Layout,
        children: [
          {
            path: 'index',
            name: 'person',
            component: () => import('@/views/person/index'),
            meta: { title: '个 人', icon: 'user' }
          }
        ]
      },
      { path: '*', redirect: '/404', hidden: true }
    ]
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERID: (state, id) => {
      console.log('SET_ID' + id)
      state.userid = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    RELOAD_ROUTES: (state) => {
      // state.role = role
      if (!Cookies.get('devices')) return
      const devicesObj = JSON.parse(Cookies.get('devices'))
      state.devices = devicesObj
      state.devices.forEach((element) => {
        const route = {
          path: `${element.devid}`,
          name: 'station' + element.devid,
          component: () => import('@/views/main/index'),
          meta: { title: element.name },
          props: { device: element }
          // params: { device: element }
        }
        state.routes[3].children.push(route)
        state.routes[3].redirect = '/stations/' + state.routes[3].children[0].path
      })
      // console.log('user-routes:')
      // console.log(state.routes)
      router.options.routes = state.routes
      router.addRoutes(state.routes)
    },
    SET_DEVICES: (state, devices) => {
      state.devices = devices
      state.devices.forEach((element) => {
        const route = {
          path: `${element.devid}`,
          name: 'station' + element.devid,
          component: () => import('@/views/main/index'),
          meta: { title: element.name },
          props: { device: element }
          // params: { device: element }
        }
        state.routes[3].children.push(route)
        state.routes[3].redirect = '/stations/' + state.routes[3].children[0].path
      })
      // console.log('user-routes:')
      // console.log(state.routes)
      router.options.routes = state.routes
      Cookies.set('devices', devices)
      // 替换现有router的routes
      router.addRoutes(state.routes)
    }
  },

  actions: {
    // 登录
    async Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      let response = await login(username, userInfo.password)
      let data = response.data
      console.log(data)
      setToken(data.token)
      commit('SET_TOKEN', data.token)
      commit('SET_USERID', data.id)
      commit('SET_ROLE', data.role)
      commit('SET_NAME', data.username)
      response = await queryDevices(data.id)
      console.log('DEVICES')
      console.log(response)
      data = response.data
      commit('SET_DEVICES', data)
    },

    async updateUserPwd({ commit }, pwdParams) {
      await modifyPassword(pwdParams)
    },
    async register({ commit }, params) {
      await register(params)
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then((response) => {
            const data = response.data
            if (data.roles && data.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit('SET_ROLES', data.roles)
            } else {
              reject(new Error('getInfo: roles must be a non-null array !'))
            }
            commit('SET_NAME', data.name)
            commit('SET_AVATAR', data.avatar)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    async LogOut({ commit, state }) {
      await logout(state.token)
      commit('SET_TOKEN', '')
      commit('SET_ROLES', 1)
      state.routes[3].children = []
      commit('SET_DEVICES', [])

      removeToken()
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        removeToken()
        commit('SET_TOKEN', '')
        resolve()
      })
    }
  }
}

export default user
